var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { deleteNullFromJson } from './delete-nulls-from-json';
var DataSourceUtils = /** @class */ (function (_super) {
    __extends(DataSourceUtils, _super);
    function DataSourceUtils(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.params = {};
        _this.selection = new SelectionModel(true, []);
        return _this;
    }
    DataSourceUtils.prototype.connect = function () {
        var _this = this;
        return this.onConnect()
            .do(function (_a) {
            var data = _a[0], total = _a[1];
            _this.data = data;
            _this.total = total;
        })
            .map(function (_a) {
            var data = _a[0], total = _a[1];
            return data;
        })
            .do(function (data) { return (_this.empty = !!data.length); })
            .do(function () {
            _this.selection.clear();
        });
    };
    DataSourceUtils.prototype.update = function () { };
    DataSourceUtils.prototype.onConnect = function () {
        return Observable.of([[], 0]);
    };
    DataSourceUtils.prototype.disconnect = function () { };
    DataSourceUtils.prototype.search = function (params) {
        this.addParams(__assign({}, params, {
            page: 1
        }));
        this.pageIndex = 0;
        this.update();
    };
    DataSourceUtils.prototype.page = function (event) {
        this.addParams({
            limit: event.pageSize,
            page: event.pageIndex + 1
        });
        this.update();
    };
    DataSourceUtils.prototype.sort = function (event) {
        this.addParams({
            orderColumn: event.active,
            direction: event.direction.toUpperCase()
        });
        this.update();
    };
    DataSourceUtils.prototype.addParams = function (params) {
        this.params = Object.assign(this.params, params);
        this.params = deleteNullFromJson(this.params);
    };
    DataSourceUtils.prototype.isAllSelected = function () {
        var numSelected = this.selection.selected.length;
        var numRows = this.data.length;
        return numSelected === numRows;
    };
    DataSourceUtils.prototype.masterToggle = function () {
        var _this = this;
        this.isAllSelected() ? this.selection.clear() : this.data.forEach(function (row) { return _this.selection.select(row); });
    };
    return DataSourceUtils;
}(DataSource));
export { DataSourceUtils };
